// extracted by mini-css-extract-plugin
module.exports = {"skillTag":"_5oEnZ","skillTagSpan":"Zb8TO","skillTagTooltip":"myuqA","deleteLoading":"tN7da"};